import { render } from "./DashboardUpcoming.vue?vue&type=template&id=f22c3b62&scoped=true&ts=true&lang=pug"
import script from "./DashboardUpcoming.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardUpcoming.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardUpcoming.vue?vue&type=style&index=0&id=f22c3b62&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22c3b62"]])

export default __exports__